import type React from 'react';
import { useState } from 'react';
import { useVimeoPlayerAnalytics } from '../../utils/vimeoPlayer';
import { useCatalogLoggingContext } from '../../Catalog.logging';

type UseCurationVideoPlayerAnalyticsArgs = {
  element: HTMLIFrameElement | null;
  curationId: string;
  curationTitle: Maybe<string>;
  iframeRef?: React.Ref<HTMLIFrameElement>;
};
export const useCurationVideoPlayerAnalytics = (args: UseCurationVideoPlayerAnalyticsArgs) => {
  const { curationId, curationTitle } = args;
  const {
    trackCurationVideoPlaybackStarted,
    trackCurationVideoPlaybackPaused,
    trackCurationVideoPlaybackResumed,
    trackCurationVideoPlaybackCompleted,
    trackCurationVideoContentStarted,
    trackCurationVideoContentPlaying,
    trackCurationVideoContentCompleted,
  } = useCatalogLoggingContext();

  const [isPlaying, setIsPlaying] = useState(false);

  const { vimeoIframeRef } = useVimeoPlayerAnalytics({
    handlers: {
      onPlaybackStarted: metadata => {
        setIsPlaying(true);
        trackCurationVideoPlaybackStarted({ id: curationId, title: curationTitle }, metadata);
      },
      onPlaybackCompleted: metadata => {
        setIsPlaying(false);
        trackCurationVideoPlaybackCompleted({ id: curationId, title: curationTitle }, metadata);
      },
      onPlaybackPaused: metadata => {
        setIsPlaying(false);
        trackCurationVideoPlaybackPaused({ id: curationId, title: curationTitle }, metadata);
      },
      onPlaybackResumed: metadata => {
        setIsPlaying(true);
        trackCurationVideoPlaybackResumed({ id: curationId, title: curationTitle }, metadata);
      },

      onContentStarted: metadata => {
        trackCurationVideoContentStarted({ id: curationId, title: curationTitle }, metadata);
      },
      onContentPlaying: metadata => {
        setIsPlaying(true);
        trackCurationVideoContentPlaying({ id: curationId, title: curationTitle }, metadata);
      },
      onContentCompleted: metadata => {
        trackCurationVideoContentCompleted({ id: curationId, title: curationTitle }, metadata);
      },
    },
  });

  return {
    vimeoIframeRef,
    isPlaying,
  };
};
